import KeyValueCollection, {getDefaultState as getDefaultRgaKeyValueCollection} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';

import t from 'tcomb';

const RgaRecallStatus = t.struct({
    currentStatus: t.list(KeyValuePair),
    genericStatus: t.list(KeyValuePair),
    infoReqStatus: t.list(KeyValuePair),
    partReqStatus: t.list(KeyValuePair),
    photoReqStatus: t.list(KeyValuePair)
}, 'RgaRecallStatus');

export const getDefaultRgaRecallStatusState = () => new RgaRecallStatus({
    currentStatus: [],
    genericStatus: [],
    infoReqStatus: [],
    partReqStatus: [],
    photoReqStatus: []
});

const RgaDomainValues = t.struct({
    analysisStatus: KeyValueCollection,
    requesterType: KeyValueCollection,
    rgaRecallStatus: RgaRecallStatus,
    rgaUnits: t.list(KeyValuePair)
}, 'RgaDomainValues');

export const getDefaultState = () => new RgaDomainValues({
    analysisStatus: getDefaultRgaKeyValueCollection(),
    requesterType: getDefaultRgaKeyValueCollection(),
    rgaRecallStatus: getDefaultRgaRecallStatusState(),
    rgaUnits: []
});

export default RgaDomainValues;



// WEBPACK FOOTER //
// ./src/rga/shared/rga-domain-values/state/rga-domain-values.js